module.exports = __webpack_public_path__ + "static/media/elves-grey.67aec432.svg";